/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from './comms-sends-view.ngfactory';
import * as i3 from '../../../app/components/comms-sends-view';
import * as i4 from '@ngrx/store/src/store';
import * as i5 from '@angular/router';
import * as i6 from '@angular/platform-browser';
import * as i7 from './comms-form.ngfactory';
import * as i8 from '../../../app/components/comms-form';
import * as i9 from '@ngrx/effects/src/actions';
import * as i10 from 'ng2-completer/services/completer-service';
import * as i11 from 'angular2-token';
import * as i12 from '../../../app/components/comms-view';
const styles_CommsViewComponent:any[] = ([] as any[]);
export const RenderType_CommsViewComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_CommsViewComponent,data:{}});
function View_CommsViewComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),3,'button',[['class',
      'cv__action-btn short']],(null as any),[[(null as any),'click']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:any = _v.component;
    if (('click' === en)) {
      const pd_0:any = ((<any>_co.clickedReloadTemplates()) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),i0.ɵdid(1,278528,(null as any),0,i1.NgClass,[i0.IterableDiffers,
      i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,'klass'],ngClass:[1,
      'ngClass']},(null as any)),i0.ɵpod(2,{'loading':0}),(_l()(),i0.ɵted(-1,(null as any),
      ['Reload Email Templates']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = 'cv__action-btn short';
    const currVal_1:any = _ck(_v,2,0,_co.isReloadingTemplates);
    _ck(_v,1,0,currVal_0,currVal_1);
  },(null as any));
}
function View_CommsViewComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'comms-sends-view',([] as any[]),
          (null as any),(null as any),(null as any),i2.View_CommsSendsViewComponent_0,
          i2.RenderType_CommsSendsViewComponent)),i0.ɵdid(2,245760,(null as any),0,
          i3.CommsSendsViewComponent,[i4.Store,i5.Router,i5.ActivatedRoute,i6.DomSanitizer],
          {mode:[0,'mode']},(null as any))],(_ck,_v) => {
    const currVal_0:any = 'email';
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
function View_CommsViewComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'comms-sends-view',([] as any[]),
          (null as any),(null as any),(null as any),i2.View_CommsSendsViewComponent_0,
          i2.RenderType_CommsSendsViewComponent)),i0.ɵdid(2,245760,(null as any),0,
          i3.CommsSendsViewComponent,[i4.Store,i5.Router,i5.ActivatedRoute,i6.DomSanitizer],
          {mode:[0,'mode']},(null as any))],(_ck,_v) => {
    const currVal_0:any = 'sms';
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
function View_CommsViewComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),4,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CommsViewComponent_3)),
      i0.ɵdid(2,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CommsViewComponent_4)),i0.ɵdid(4,16384,
          (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵand(0,(null as any),(null as any),0))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_co.activeTab == 'email');
    _ck(_v,2,0,currVal_0);
    const currVal_1:any = (_co.activeTab == 'sms');
    _ck(_v,4,0,currVal_1);
  },(null as any));
}
function View_CommsViewComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),2,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),1,'comms-form',([] as any[]),
          (null as any),(null as any),(null as any),i7.View_CommsFormComponent_0,i7.RenderType_CommsFormComponent)),
      i0.ɵdid(2,245760,(null as any),0,i8.CommsFormComponent,[i4.Store,i9.Actions,
          i5.Router,i5.ActivatedRoute,i10.CompleterService,i11.Angular2TokenService,
          i6.DomSanitizer,i0.ElementRef],{mode:[0,'mode']},(null as any))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.activeTab;
    _ck(_v,2,0,currVal_0);
  },(null as any));
}
export function View_CommsViewComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),20,'div',[['class',
      'comms-view']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(1,0,(null as any),(null as any),19,'div',[['class','cv__content-wrapper']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵeld(2,0,(null as any),(null as any),8,'ul',([] as any[]),(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵeld(3,
          0,(null as any),(null as any),3,'li',([] as any[]),(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.CommsViewComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedTab('email')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(4,278528,(null as any),0,i1.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i0.ɵpod(5,{'active':0}),(_l()(),i0.ɵted(-1,
          (null as any),['Email'])),(_l()(),i0.ɵeld(7,0,(null as any),(null as any),
          3,'li',([] as any[]),(null as any),[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.CommsViewComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedTab('sms')) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(8,278528,(null as any),0,i1.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{ngClass:[0,
              'ngClass']},(null as any)),i0.ɵpod(9,{'active':0}),(_l()(),i0.ɵted(-1,
          (null as any),['SMS'])),(_l()(),i0.ɵeld(11,0,(null as any),(null as any),
          4,'div',[['class','cv__actions']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(12,0,(null as any),(null as any),
          1,'button',[['class','cv__action-btn short']],(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i12.CommsViewComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.clickedCompose()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['Compose'])),
      (_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_CommsViewComponent_1)),
      i0.ɵdid(15,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],
          {ngIf:[0,'ngIf']},(null as any)),(_l()(),i0.ɵeld(16,0,(null as any),(null as any),
          4,'div',[['class','cv__inner-content-wrapper']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_CommsViewComponent_2)),i0.ɵdid(18,16384,
          (null as any),0,i1.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_CommsViewComponent_5)),i0.ɵdid(20,16384,(null as any),0,i1.NgIf,[i0.ViewContainerRef,
          i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any))],(_ck,_v) => {
    var _co:i12.CommsViewComponent = _v.component;
    const currVal_0:any = _ck(_v,5,0,_co.isTabActive('email'));
    _ck(_v,4,0,currVal_0);
    const currVal_1:any = _ck(_v,9,0,_co.isTabActive('sms'));
    _ck(_v,8,0,currVal_1);
    const currVal_2:any = _co.isReloadEmailTemplatesBtnVisible();
    _ck(_v,15,0,currVal_2);
    const currVal_3:boolean = !_co.isComposing;
    _ck(_v,18,0,currVal_3);
    const currVal_4:any = _co.isComposing;
    _ck(_v,20,0,currVal_4);
  },(null as any));
}
export function View_CommsViewComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'comms-view',
      ([] as any[]),(null as any),(null as any),(null as any),View_CommsViewComponent_0,
      RenderType_CommsViewComponent)),i0.ɵdid(1,245760,(null as any),0,i12.CommsViewComponent,
      [i4.Store,i9.Actions,i5.Router,i5.ActivatedRoute],(null as any),(null as any))],
      (_ck,_v) => {
        _ck(_v,1,0);
      },(null as any));
}
export const CommsViewComponentNgFactory:i0.ComponentFactory<i12.CommsViewComponent> = i0.ɵccf('comms-view',
    i12.CommsViewComponent,View_CommsViewComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/comms-view.ngfactory.ts